import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { MainFormBase } from "../main-form-base/main-form-base";

/**
 * For referencing validator function. Use this if you need to access the form itself
 */
export type FormReferencingValidatorFn = (form: MainFormBase<any>) => ValidatorFn;

/**
 * Pollux form validators
 */
export class PolluxValidators {

  /**
   * Integer only validation
   * @param control
   * @returns
   */
  public static integer(allowNullValues: boolean) {
    return (control: AbstractControl): ValidationErrors | null => {
      const val = control.value;
      if (allowNullValues && (val === null || val === '')) {
        return null;
      }
      if (typeof (val) === 'string') {
        if (isNaN(+val)) {
          return { 'invalidNumber': true };
        }
      }
      else if (!Number.isInteger(val)) {
        return { 'invalidNumber': true };
      }
      return null;
    };
  }
}
